<template>
  <v-card @click="clickItem(project._id)" elevation="3">
    <v-card-text>
      <v-row>
        <v-col cols="9" class="pb-0">
          <span class="font-weight-bold font-italic">{{ project.metagenomicId }} </span>
        </v-col>
        <!-- <v-col
          cols="3"
          class="pb-0 text-end"
          v-if="project.status != 'FINISHED'"
        >
          <v-menu transition="slide-y-transition" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn text v-bind="attrs" v-on="on" x-small>
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-for="(item, i) in menu" :key="i">
                <v-list-item-title @click="actionProfit(item.value)">{{
                  item.name
                }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col> -->
      </v-row>
      <v-row>
        <v-col class="py-0">
          <span>
            {{ project.projectName }}
          </span>
        </v-col>
      </v-row>
      <!-- <v-row>
        <v-col class="py-0">
          <span class="text-body-1">{{
            getFormatted(project.createdAt)
          }}</span>
        </v-col>
      </v-row> -->
      <v-row>
        <v-col cols="3" class="pt-0 ">
          <span class="primary--text font-weight-bold text-body-1">{{
            getStatus(project.status)
          }}</span>
        </v-col>
        <v-col cols="3" class="pt-0">
          <span class="text-body-1">{{ getProjectType(project.type) }}</span>
        </v-col>
        <!-- <v-col cols="6" class="pt-0" v-if="project.crops">
          <div v-for="(crop, index) in project.crops" :key="index">
            <span class="text-caption">{{ getCrop(crop) }}</span>
          </div>
        </v-col> -->
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
//Vuex
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
import moment from "moment";
export default {
  data: () => ({
    menu: [],
    shouldShow: true,
  }),
  props: {
    project: {
      type: Object,
      required: false,
    },
  },
  created() {
    this.menu = [{ name: this.translations.label_update, value: "edit" }];
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("user"));
    if (this.user.role == "ORG_USER") {
      this.shouldShow = false;
    }
  },
  methods: {
    actionProfit(value) {
      switch (value) {
        case "edit":
          this.$emit("updateItem", this.project._id);
          break;
      }
    },
    clickItem(value) {
      this.$emit("clickItem", value);
    },
    getFormatted(date) {
      return moment(date).format("DD-MM-YYYY");
    },
    getStatus(value) {
      return this.translations.status_projects[value] || value;
    },
    getProjectType(value) {
      console.log(value);

      let status = {
        MISS_TEST: "Miss test",
        MISS_SETUP: "Miss setuo",
        MISS_DISCOVERY: "Miss discovery",
        MISS_SETUP: "Miss setup",
      };

      return status[value];
    },
    getCrop(value) {
      return this.translations.crop_name_list[value] || value;
    },
  },
  computed: {
    ...mapGetters("session", ["currentTranslations"]),
    translations() {
      return this.currentTranslations;
    },
    ...mapState("areasList", ["crops"]),
  },
};
</script>

<style scoped></style>
